import { Text } from 'react-native'
import { styled } from '~/core/styled'

import { convertLineHeight, convertPercentageToNumber } from '~/utils'

type TitleProps = React.ComponentPropsWithRef<typeof Title>

const Title = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.bold,
      color: theme.colorTextNeutralDefault,

      lineHeight: convertPercentageToNumber(theme.letterSpacingDefault),
      textDecorationLine: theme.textDecorationLineNone,
    },
    variants: {
      variant: {
        'large-bold': {
          fontSize: theme.fontSizeSevenpulse,
          lineHeight: convertLineHeight(
            theme.fontSizeSevenpulse,
            theme.lineHeightTiny
          ),
        },
        'default-bold': {
          fontSize: theme.fontSizeSixpulse,
          lineHeight: convertLineHeight(
            theme.fontSizeSixpulse,
            theme.lineHeightTiny
          ),
        },
        'small-bold': {
          fontSize: theme.fontSizeFivepulse,
          lineHeight: convertLineHeight(
            theme.fontSizeFivepulse,
            theme.lineHeightTiny
          ),
        },
      },
    },
  }
})

export { Title }
export type { TitleProps }
